import React from "react";
import { Text } from "native-base";
import { ScrollView as RNScrollView, StyleSheet, View } from "react-native";

import { useAppContext } from "../../../../Universal/API/Context-API/AppContext";
import { webFont } from "../../../../Universal/API/API";
import { BackButtonBackHome } from "../../../../Universal/Buttons/BackButtonBackHomeModified";

type FilterSlideEmptyStateProps = {
  onBackToTypes: () => void;
};

const FilterSlideEmptyState: React.FC<FilterSlideEmptyStateProps> = ({
  onBackToTypes,
}) => {
  const { scaleAll } = useAppContext();
  const styles = React.useMemo(() => createStyles(scaleAll), [scaleAll]);

  return (
    <RNScrollView
      style={{ flex: 1 }}
      contentContainerStyle={styles.content}
    >
      <View style={styles.shell}>
        <BackButtonBackHome onPress={onBackToTypes} />

        <View style={styles.card}>
          <Text selectable={false} style={styles.title}>
            Сначала выберите категорию
          </Text>
          <Text selectable={false} style={styles.description}>
          Сначала выберите категорию на предыдущем экране.
          </Text>
        </View>
      </View>
    </RNScrollView>
  );
};

const createStyles = (scaleAll: number) =>
  StyleSheet.create({
    content: {
      paddingHorizontal: 16 * scaleAll,
      paddingTop: 12 * scaleAll,
      paddingBottom: 48 * scaleAll,
      flexGrow: 1,
      alignItems: "center",
    },
    shell: {
      width: "100%",
      maxWidth: 1480 * scaleAll,
      alignSelf: "center",
    },
    card: {
      marginTop: 22 * scaleAll,
      borderRadius: 28 * scaleAll,
      paddingHorizontal: 18 * scaleAll,
      paddingVertical: 20 * scaleAll,
      backgroundColor: "#FBFBFA",
      borderWidth: 1,
      borderColor: "#ECE8E1",
    },
    title: {
      fontFamily: webFont("Inter"),
      fontSize: 20 * scaleAll,
      lineHeight: 25 * scaleAll,
      color: "#111111",
      fontWeight: "700",
      marginBottom: 8 * scaleAll,
    },
    description: {
      fontFamily: webFont("Inter"),
      fontSize: 14 * scaleAll,
      lineHeight: 20 * scaleAll,
      color: "#6F6A63",
      fontWeight: "500",
    },
  });

export default React.memo(FilterSlideEmptyState);
